import { FormikValues } from 'formik';
import React, { useRef, useEffect } from 'react';

import { Card } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';

import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateProduct } from '../Product.hooks';
import { Product } from '../Product.interface';

const ProductIntendedUseCard: React.FC<{
  product: Product;
  onChange?: (product: Product) => void;
}> = ({ product, onChange }) => {
  const { intendedUse } = product;
  const formikRef = useRef<FormikValues>();
  const onChangeRef = useRef(onChange);
  const {
    updatedProduct,
    isUpdating,
    updateError,
    updateProduct
  } = useUpdateProduct(product.id);
  const { isFieldDisabled } = useTaskEntityFields(product.task);
  useEffect(
    () => void (updatedProduct && onChangeRef.current?.(updatedProduct)),
    [updatedProduct]
  );
  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        Intended Use
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={updateError}
          isSubmitting={isUpdating}
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{ intendedUse: intendedUse || '' }}
          onSubmit={(dto: Partial<Product>) => {
            updateProduct(dto);
          }}
        >
          <InlineForm>
            <InlineTextField
              name='intendedUse'
              label='Intended Use'
              placeholder='Enter Intended Use'
              multiline={true}
              disabled={isFieldDisabled('intendedUse')}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default ProductIntendedUseCard;
